import React from "react";

// import Header from "../common/header";
// import Footer from "../common/footer";
// import { MessagePage } from "../common/messagebox";

import bg from "../../static/img/backgrounds/search-document-3.svg";
import ic from "../../static/img/backgrounds/search-document.svg";

class NotFound extends React.Component {
    componentDidMount() {
        window.scrollTo(0, 0);
    }

    render() {
        return (
					<div>
					<div className="error__sect" style={{backgroundImage: `url(${bg})`}}>
						<div className="error-content">
							<div className="flexbox"><span className="error-icon" style={{backgroundImage: `url(${ic})`}} />
								<div className="flex-1">
									<h1 className="error-code">404</h1>
									<h3 className="font-strong">NOT FOUND</h3>
									<p>Sorry, the page you were looking for could not found.</p>
								</div>
							</div>
							<div className="text-center mb-3 mt-5"><a className="text-primary" href="/">Go Homepage</a></div>
						</div>
					</div>
					{/* BEGIN PAGA BACKDROPS*/}
					{/* <div className="sidenav-backdrop backdrop" />
					<div className="preloader-backdrop">
						<div className="page-preloader">Loading</div>
					</div> */}
				</div>
        );
    }
}

export default NotFound;


// WEBPACK FOOTER //
// ./src/components/common/notfound.js